export default {
  methods: {
    downloadFile: function (rawFile, format = '.mp3', fileName) {
      const url = window.URL.createObjectURL(new Blob([rawFile]));
      const link = document.createElement('a');
      link.href = url;
      const today = new Date();

      const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
      link.setAttribute('download', fileName || date + format);
      document.body.appendChild(link);
      link.click();
    },
  },
};
